import React, { useState } from 'react';
import {Badge, Button, Divider, Modal, Space} from 'antd';
import {Checkbox, Col, Popover, Row, Tag} from "antd";

import {CheckCircleOutlined} from "@ant-design/icons";
import {observer} from "mobx-react-lite";


const Vozvraty20203 = observer((props) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const showModal = () => {
        setIsModalOpen(true);
    };
    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };
    return (

        <>
            {(props.voz==true)?(
                // <Button type="primary" color={"red"}  value="small"onClick={showModal} shape="circle">{props.dta.cancelCount}</Button>
                // <Badge  onClick={showModal} color={"red"} showZero={false} count={props.dta.cancelCount}></Badge>
                <Space direction="vertical" size={4}   style={{ width: '100%', color: "black" }} >
                <Tag
                    color="red"
                    onClick={showModal}
                    style={{
                        // width: '100%',
                        color: 'black',
                        textAlign: 'center',      // Центрирование текста
                        // display: 'block',          // Обязательно для корректного выравнивания в 100% ширины
                        cursor: 'pointer'
                    }}
                >
                    {props.dta.cancelCount}
                </Tag>
                </Space>

            ):(

                <Tag
                    color="green"
                    onClick={showModal}
                    style={{
                        // width: '100%',
                        color: 'black',
                        textAlign: 'center',      // Центрирование текста
                        // display: 'block',          // Обязательно для корректного выравнивания в 100% ширины
                        cursor: 'pointer'
                    }}
                >
                    {props.dta.zakazCount}
                </Tag>

              // <Badge style={{ whiteSpace: 'pre-line', textAlign: 'center', color:"black" }} onClick={showModal} color={"lime"} showZero={false} count={props.dta.zakazCount}></Badge>
                )}
            {/*<Button type="primary" onClick={showModal}>*/}
            {/*    props.dta.zakazCount*/}
            {/*</Button>*/}
            <Modal   width={1600} title="Заказы" open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
                {Object.entries(props.dta.Orders)
                             .map( ([key, value]) =>
                                    <>
                                        <Divider >{value.ship_date_str} - {value.posting_number} </Divider>
                                        {/*<h3>Заказ: {value.posting_number}</h3>*/}
                                     <Row  align="middle">
                                         <Col span={3}>
                                             <div className={"virov"}>
                                                 {value.ship_date_str}
                                             </div>
                                         </Col>
                                         {/*<Col span={6}>*/}
                                         {/*    <div className={"virov"}>*/}
                                         {/*        {value.posting_number}*/}
                                         {/*    </div>*/}
                                         {/*</Col>*/}
                                         <Col span={3}>
                                             <div className={"virov"}>
                                                 {value.status_rus}
                                             </div>
                                         </Col>
                                         {/*<Col span={6}>*/}
                                         {/*    <div className={"virov"}>*/}
                                         {/*        {value.substatus_rus}*/}
                                         {/*    </div>*/}
                                         {/*</Col>*/}


                                         {(value.Cancel_reason!="")?

                                             (
                                                 <>
                                                     {/*<a>AAA={value.Cancel_reason}</a>*/}
                                                     <Col span={7}>
                                                         {value.prodlist.map((valuez) =>
                                                             <p>{valuez}</p>
                                                         )} </Col>
                                                 <Col span={5}>
                                                     <Tag color={"red"}>{value.Cancel_reason}</Tag>
                                         </Col>
                                                 </>
                                         ):(<>
                                                 {/*<a>BBB={value.Cancel_reason}</a>*/}
                                                 <Col span={15}>
                                                     {value.prodlist.map((valuez) =>
                                                         <p>{valuez}</p>
                                                     )} </Col>
                                             </>)}

                                     </Row>


                            </>

                        )}
                {/*<h3>Товары</h3>*/}
                {/*{Object.entries(props.dta.tovars)*/}
                {/*    .map( ([key, value]) =>*/}

                {/*        <Row  align="middle">*/}
                {/*            <Col span={6}>*/}
                {/*                <div className={"virov"}>*/}
                {/*                    {value.offer_id}*/}
                {/*                </div>*/}
                {/*            </Col>*/}
                {/*            <Col span={15}>*/}
                {/*                <div className={"virov"}>*/}
                {/*                    {value.name}*/}
                {/*                </div>*/}
                {/*            </Col>*/}
                {/*            <Col span={2}>*/}
                {/*                <div className={"virov"}>*/}
                {/*                    {value.quantity}шт*/}
                {/*                </div>*/}
                {/*            </Col>*/}

                {/*        </Row>*/}


                {/*    )}*/}

            </Modal>
        </>
        // <>
        //     {
        //         Object.entries(props.dta.Orders)
        //             .map( ([key, value]) =>
        //                     <Row  align="middle">
        //                         <Col span={2}>
        //                             <div className={"virov"}>
        //                                 {value.ship_date_str}
        //                             </div>
        //                         </Col>
        //                         <Col span={2}>
        //                             <div className={"virov"}>
        //                                 {value.posting_number}
        //                             </div>
        //                         </Col>
        //                         <Col span={2}>
        //                             <div className={"virov"}>
        //                                 {value.status_rus}
        //                             </div>
        //                         </Col>
        //
        //                     </Row>
        //             // <p>{value.ship_date_str}{value.posting_number}{value.status_rus}</p>
        //             // <a>sss</a>
        //             //     </>
        //
        //             )
        //
        //     }
        //
        //
        // </>

    );
})

export default Vozvraty20203;